export default __webpack_public_path__ + "static/media/dev-connector.e12fb4b0.mp4";